'use client';

import { PlayIcon, PauseIcon } from '@heroicons/react/24/solid';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { Button, HeroIcon } from '@/components/atoms';

export const PlayPauseButton = () => {
  const t = useTranslations();
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => setIsPlaying(prev => !prev);

  return (
    <Button
      onClick={togglePlay}
      aria-label={isPlaying ? t('FOCAL_PAUSE') : t('FOCAL_PLAY')}
    >
      <HeroIcon icon={isPlaying ? PauseIcon : PlayIcon} />
    </Button>
  );
};
